import { useSelector } from 'react-redux';
import { UnauthenticatedHeaderSmall, NoAccountUnauthenticatedHeaderSmall } from './unauthenticated-header.js';
import useConfiguration from '~/configuration/use-configuration.js';
import useTranslations from '~/components/translation/use-translations.ts';
import { authenticationSelector } from '../authentication/ducks/selectors.js';
import useGuestLogin from '~/components/guest-login/hooks/use-guest-login';
import useDisplayGlobalNavigation from '~/components/global-navigation/use-display-global-navigation';
import {
	selectShowLoginAsGuestOption,
	selectOneButtonFlowEnabled
} from '~/store/feature-toggles/onboarding-feature-toggles';

const textKeys = ['MOBILE_TRUSTLY_DEPOSIT_LOGIN', 'MOBILE_LOGIN_REGISTRATION', 'MOBILE_PAG_LOGIN', 'MOBILE_PLAY_NOW'];

const HeaderSelector = ({ hasBottomOffset = false }) => {
	const { redirectToGuestLogin } = useGuestLogin();
	const { isAnonymous } = useConfiguration();
	const showLoginAsGuestOption = useSelector(selectShowLoginAsGuestOption);
	const { translations: t } = useTranslations(textKeys);
	const authenticated = useSelector(authenticationSelector);
	const oneBankIDFlowEnabled = useSelector(state => state.brand.oneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlowEnabled);
	const blackFridayCampaignEnabled = useSelector(state => state.brand.blackFridayCampaignEnabled);
	const { displayGlobalNavigation } = useDisplayGlobalNavigation();

	if (isAnonymous && !authenticated) {
		return (
			<NoAccountUnauthenticatedHeaderSmall
				text={t.MOBILE_TRUSTLY_DEPOSIT_LOGIN}
				onClick={() => {
					redirectToGuestLogin();
				}}
				blackFridayCampaignEnabled={blackFridayCampaignEnabled}
				hasBottomOffset={hasBottomOffset}
				displayGlobalNavigation={displayGlobalNavigation}
			/>
		);
	}

	if (!authenticated) {
		return (
			<UnauthenticatedHeaderSmall
				showLoginAsGuestOption={showLoginAsGuestOption}
				playAsGuestTitleText={t.MOBILE_PAG_LOGIN}
				oneBankIDFlowEnabled={oneBankIDFlowEnabled}
				oneButtonFlow={oneButtonFlow}
				createAccountTitleText={
					oneBankIDFlowEnabled || oneButtonFlow ? t.MOBILE_PLAY_NOW : t.MOBILE_LOGIN_REGISTRATION
				}
				hasBottomOffset={hasBottomOffset}
				displayGlobalNavigation={displayGlobalNavigation}
			/>
		);
	}

	return null;
};

export default HeaderSelector;
